import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HotRankingSection from './components/HotRankingSection';
import FeaturedGrid from './components/FeaturedGrid';
import { hotArticles, featuredArticles, categories } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function Home() {
  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "911爆料网",
    "alternateName": "91吃瓜黑料网",
    "url": "https://911baoliao.com/",
    "logo": "https://911baoliao.com/logo.png",
    "description": "911爆料网 - 全网独家爆料首发平台，提供今日最新大瓜、网红黑料曝光、明星塌房事件实时追踪，海量独家内幕免费开放。",
    "sameAs": [
      "https://weibo.com/911baoliao",
      "https://mp.weixin.qq.com/911baoliao"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "爆料投稿",
      "availableLanguage": ["Chinese", "Simplified Chinese"]
    }
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "911爆料网 - 今日最新大瓜爆料",
    "url": "https://911baoliao.com/",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://911baoliao.com/search?q={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    },
    "publisher": {
      "@type": "Organization",
      "name": "911爆料网",
      "url": "https://911baoliao.com/"
    }
  };

  const webpageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "911爆料网 - 今日最新大瓜爆料",
    "description": "911爆料网吃瓜频道今日最新大瓜持续首发，网红黑料曝光、明星塌房事件全程实时追踪，海量独家爆料内容免费开放，24小时不打烊。",
    "url": "https://911baoliao.com/",
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://911baoliao.com/" }
      ]
    },
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": hotArticles.slice(0, 6).map((a, i) => ({
        "@type": "ListItem",
        "position": i + 1,
        "url": `https://911baoliao.com/article/${a.slug}`,
        "name": a.title
      }))
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "911爆料网的内容来源是什么？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "本站内容来自网友投稿、合作媒体及公开信息整理，所有爆料均经过编辑团队初步核实后发布。"
        }
      },
      {
        "@type": "Question",
        "name": "如何向911爆料网投稿爆料？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "您可以通过页面底部的爆料投稿链接或发送邮件至我们的官方邮箱，编辑将在24小时内审核回复。"
        }
      },
      {
        "@type": "Question",
        "name": "爆料内容的真实性如何保证？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "我们建立了多层审核机制，标注已核实的内容均经过了至少双重验证。未核实内容也会明确标注。"
        }
      },
      {
        "@type": "Question",
        "name": "如何订阅最新爆料推送？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "在订阅框中输入您的邮箱地址，我们将第一时间通过邮件推送最新热点爆料。"
        }
      }
    ]
  };

  return (
    <>
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[500px] md:h-[620px] flex items-end">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20composition%20with%20warm%20red%20and%20deep%20black%20gradient%2C%20dramatic%20spotlight%20effect%2C%20mysterious%20cinematic%20atmosphere%2C%20no%20people%2C%20editorial%20breaking%20news%20style%2C%20rich%20texture%20and%20deep%20contrast%2C%20professional%20photography&width=1600&height=700&seq=hero-main-bg-2026&orientation=landscape"
            alt="911爆料网 - 全网独家爆料首发平台"
            title="911爆料网 - 全网独家爆料首发平台"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>

          <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 pb-14 md:pb-20">
            <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full border border-white/30 text-white text-xs font-medium mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse mr-0.5"></span>
              24H实时追踪
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-light text-white leading-tight max-w-xl">
              全网独家爆料
              <br />
              <strong className="font-bold">第一手黑料曝光</strong>
            </h1>
            <p className="mt-4 text-white/70 text-sm md:text-base max-w-md leading-relaxed">
              今日最新大瓜持续首发，网红黑料、明星塌房全程追踪，海量独家内幕免费开放
            </p>
            <div className="flex items-center gap-3 mt-6">
              <Link
                to="/category/today-hot"
                className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-primary-600"
              >
                立即吃瓜
              </Link>
              <Link
                to="/about"
                className="px-6 py-3 rounded-full border border-white/40 text-white text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 hover:border-white hover:bg-white/10"
              >
                爆料投稿
              </Link>
            </div>
          </div>
        </section>

        {/* Category Quick Links */}
        <section className="py-6 md:py-8 bg-background-50 border-b border-background-200/60">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="flex items-center gap-2 md:gap-3 overflow-x-auto pb-1" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex-shrink-0 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-100 text-foreground-700 text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-primary-50 hover:text-primary-600"
                >
                  <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Latest Breaking News */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
                最新爆料
              </h2>
              <Link
                to="/category/realtime-expose"
                className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line w-3.5 h-3.5 inline-flex items-center justify-center"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {hotArticles.slice(0, 4).map((article) => (
                <ArticleCard key={article.id} article={article} variant="grid" />
              ))}
            </div>
          </div>
        </section>

        {/* Hot Ranking */}
        <HotRankingSection articles={hotArticles.slice(0, 8)} />

        {/* Featured Grid */}
        <FeaturedGrid articles={featuredArticles} />

        {/* Live Updates Section */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="mb-8">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
                实时追踪
                <span className="inline-flex items-center ml-3 px-2 py-0.5 rounded text-xs font-sans font-medium bg-accent-100 text-accent-700">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-500 mr-1.5 animate-pulse"></span>
                  LIVE
                </span>
              </h2>
              <p className="text-xs text-foreground-500 mt-1.5">24小时不打烊，第一时间掌握全网热议内幕</p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
              {hotArticles.slice(0, 6).map((article, index) => (
                <ArticleCard key={article.id} article={article} variant="list" rank={index + 1} />
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              不错过任何一个瓜
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto leading-relaxed">
              订阅911爆料网推送，第一时间获取全网最新爆料，做朋友圈里消息最灵通的那个人
            </p>
            <form
              data-readdy-form="d95memea5sk3luk4pg70"
              className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);

                const honeypotVal = (formData.get('website_alt') as string || '').trim();
                if (honeypotVal) {
                  const successMsg = document.getElementById('cta-subscribe-success');
                  const errorMsg = document.getElementById('cta-subscribe-error');
                  if (successMsg) successMsg.classList.remove('hidden');
                  if (errorMsg) errorMsg.classList.add('hidden');
                  form.reset();
                  return;
                }

                const submitBtn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
                const successMsg = document.getElementById('cta-subscribe-success');
                const errorMsg = document.getElementById('cta-subscribe-error');
                const errorText = document.getElementById('cta-error-text');
                if (submitBtn) submitBtn.disabled = true;

                try {
                  const response = await fetch('https://readdy.ai/api/form/d95memea5sk3luk4pg70', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                  });
                  const responseText = await response.text();
                  let parsed: Record<string, unknown> = {};
                  try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

                  if (response.ok && (parsed as { code?: string })?.code === 'OK') {
                    if (successMsg) successMsg.classList.remove('hidden');
                    if (errorMsg) errorMsg.classList.add('hidden');
                    form.reset();
                  } else {
                    const serverMsg = ((parsed as { meta?: { message?: string } })?.meta?.message) || ((parsed as { message?: string })?.message) || responseText || '订阅失败，请稍后重试';
                    if (errorText) errorText.textContent = typeof serverMsg === 'string' ? serverMsg : String(serverMsg);
                    if (errorMsg) errorMsg.classList.remove('hidden');
                    if (successMsg) successMsg.classList.add('hidden');
                  }
                } catch {
                  if (errorText) errorText.textContent = '网络错误，请检查连接后重试';
                  if (errorMsg) errorMsg.classList.remove('hidden');
                  if (successMsg) successMsg.classList.add('hidden');
                } finally {
                  if (submitBtn) submitBtn.disabled = false;
                }
              }}
            >
              <input
                type="email"
                name="email"
                required
                placeholder="输入你的邮箱地址"
                className="flex-1 w-full sm:w-auto px-5 py-3 rounded-full bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors"
              />
              <button
                type="submit"
                className="w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-primary-600"
              >
                立即订阅 <i className="ri-arrow-right-line w-4 h-4 inline-flex items-center justify-center ml-1"></i>
              </button>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
            </form>
            <div id="cta-subscribe-success" className="hidden mt-4 text-sm text-accent-600 font-medium">
              订阅成功！最新大瓜将通过邮箱第一时间送达！
            </div>
            <div id="cta-subscribe-error" className="hidden mt-4 text-sm text-primary-500 font-medium">
              <span id="cta-error-text">订阅失败，请稍后重试</span>
            </div>
            <div className="mt-10 flex items-center justify-center gap-6 opacity-40">
              <i className="ri-camera-line w-6 h-6 flex items-center justify-center text-foreground-400"></i>
              <i className="ri-flashlight-line w-6 h-6 flex items-center justify-center text-foreground-400"></i>
              <i className="ri-mic-line w-6 h-6 flex items-center justify-center text-foreground-400"></i>
              <i className="ri-search-eye-line w-6 h-6 flex items-center justify-center text-foreground-400"></i>
              <i className="ri-alert-line w-6 h-6 flex items-center justify-center text-foreground-400"></i>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="mb-8">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
                常见问题
              </h2>
              <p className="text-xs text-foreground-500 mt-1.5">关于911爆料网，你想知道的都在这里</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl">
              {[
                { q: '911爆料网的内容来源是什么？', a: '本站内容来自网友投稿、合作媒体及公开信息整理，所有爆料均经过编辑团队初步核实后发布。' },
                { q: '如何向911爆料网投稿爆料？', a: '您可以通过页面底部的爆料投稿链接或发送邮件至我们的官方邮箱，编辑将在24小时内审核回复。' },
                { q: '爆料内容的真实性如何保证？', a: '我们建立了多层审核机制，标注已核实的内容均经过了至少双重验证。未核实内容也会明确标注。' },
                { q: '如何订阅最新爆料推送？', a: '在上方订阅框中输入您的邮箱地址，我们将第一时间通过邮件推送最新热点爆料。' },
              ].map((faq, i) => (
                <details key={i} className="group border border-background-200/70 rounded-lg p-4 cursor-pointer transition-colors hover:border-background-300">
                  <summary className="text-sm font-semibold text-foreground-900 list-none flex items-center justify-between">
                    {faq.q}
                    <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center transition-transform group-open:rotate-180 text-foreground-400"></i>
                  </summary>
                  <p className="mt-3 text-xs text-foreground-600 leading-relaxed">{faq.a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* SEO Structured Data */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify(orgSchema)
        }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify(websiteSchema)
        }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify(webpageSchema)
        }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify(faqSchema)
        }} />
      </main>

      <Footer />
    </>
  );
}